import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserDto } from '@api/generated/bff';
import { useUser } from '@hooks/useUser.ts';
import { useAuthStore } from '@stores/authStore.ts';

/**
 * Připomínka, že za session sedí admin přihlášený jako někdo jiný.
 *
 * V anonymním okně se snadno zapomene, čí účet je zrovna na obrazovce – bez varování
 * hrozí, že admin začne klikat naostro pod cizí identitou.
 *
 * Záměrně NENÍ `fixed`: layouty ho vykreslují v normálním toku nad hlavičkou
 * (`TopInformation` stojí ve všech třech layoutech hned nad `Header`em, který sám
 * fixed/sticky není), takže menu i obsah se posunou pod něj samy. Fixed pruh
 * hlavičku překrýval.
 */
export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation('client');
  const { beUser } = useUser();
  const logout = useAuthStore(s => s.logout);

  // `impersonatedBy` přibylo v BFF; do generovaného typu se dostane až přegenerováním klienta.
  const impersonatedBy = (beUser as UserDto & { impersonatedBy?: number | null })?.impersonatedBy;

  if (!impersonatedBy) return null;

  const userName = `${beUser.firstName || ''} ${beUser.familyName || ''}`.trim() || beUser.email || '';

  return (
    <div className="bg-red-600 text-white shadow-md">
      <div className="px-4 py-2 flex items-center justify-between gap-4">
        <div className="text-sm font-medium">
          <i className="fas fa-user-secret mr-2"></i>
          {t('shared.impersonation.active', { user: userName })}
        </div>
        <button
          onClick={() => logout()}
          className="inline-flex items-center px-3 py-1 text-sm font-medium rounded-md bg-white text-red-700 hover:bg-red-50 transition-colors duration-200 shrink-0"
        >
          {t('shared.impersonation.end')}
        </button>
      </div>
    </div>
  );
};
